import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  useUserCanManageSeatSaver,
  useUserCanUpdateListing,
} from 'src/hooks/useUserHasListingPermissions';
import { ListingNotesSection } from 'src/modals/common';
import {
  Listing,
  ListingDetailsUpdateInput,
  ListingNote,
} from 'src/WebApiController';

export const NotesSection = ({
  listing,
  disabled,
  isBulkEdit,
}: {
  listing?: Listing | null;
  disabled?: boolean;
  isBulkEdit?: boolean;
}) => {
  const { watch, setValue } = useFormContext<ListingDetailsUpdateInput>();
  const internalNotes = watch('internalNotes');
  const seatTraits = watch('seatTraits');

  const canUpdateRegularListing = useUserCanUpdateListing(listing, false);
  const hasManageSeatSaverPermission = useUserCanManageSeatSaver();
  const canUpdate =
    isBulkEdit || !listing
      ? hasManageSeatSaverPermission || canUpdateRegularListing
      : listing.isSeatSaver
        ? hasManageSeatSaverPermission
        : canUpdateRegularListing;

  const onListingNotesChanged = useCallback(
    (listingNotes?: ListingNote[] | null) => {
      setValue('seatTraits', listingNotes ?? null);
    },
    [setValue]
  );

  const onInternalNotesChanged = useCallback(
    (notes?: string | null) => {
      setValue('internalNotes', notes ?? null);
    },
    [setValue]
  );

  if (isBulkEdit) {
    return null;
  }

  return (
    <ListingNotesSection
      listingNotes={seatTraits ?? listing?.seatTraits}
      internalNotes={internalNotes}
      allowEditListingNotes={canUpdate}
      disabled={disabled || !canUpdate}
      onListingNotesChanged={onListingNotesChanged}
      onInternalNotesChanged={onInternalNotesChanged}
    />
  );
};
